import sliceCreator from '../../index.js';
import {STORE_MANAGER_GET_STOCK} from '../../../constants/index.js';
const _getStockManagementAction = sliceCreator('STORE_MANAGER_GET_STOCK', STORE_MANAGER_GET_STOCK, 'get');

const { asyncAction: getStockManagementAction, reducer, clearData: clearGetStockManagementAction } = _getStockManagementAction;

export default reducer;

export {
    getStockManagementAction,
    clearGetStockManagementAction
}